"use strict";

import { timeStringToDate } from './utils';

import { Iconsulta } from './consultaUtils';
import { Icartao } from './cartaoUtils';
import { Iutente } from './utentesUtils';
import { errorFuncStruct, conection } from './conectionUtils';
import { Iterapeuta } from './terapeutasUtils';

export type DiaSemana = 'segunda' | 'terca' | 'quarta' | 'quinta' | 'sexta';

export type DiaSemanaObject = {value: string; text: string; abrev: string; index: number};

export type MarcacoesHoje = {
  id: number;
  hora: string;
  id_terapeuta: number;
  flag_especial: number;
  terapeuta: string;
  total: number;
  n_tratamentos: number;
  diagnostico: string;
  diagnostico_pesquisa: string;
  tratamento: string | undefined;
  ap: string | undefined;
  nome: string;
  nome_pesquisa: string;
  codigo: string;
  id_utente: number;
  telefone: string;
  status: number;
  data: string;
  data_fim_transporte: string;
  id_cartao: number;
  next_consulta: number;
  consulta_alta: number;
  obs: string;
  falta: number;
}

export const diasSemana: DiaSemanaObject[] = [
  {value: "segunda", text: "Segunda", abrev: "S", index: 1},
  {value: "terca", text: "Terça", abrev: "T", index: 2},
  {value: "quarta", text: "Quarta", abrev: "Q", index: 3},
  {value: "quinta", text: "Quinta", abrev: "Q", index: 4},
  {value: "sexta", text: "Sexta", abrev: "S", index: 5},
]

export interface Imarcacao{
  id?: number;
  id_consulta: number;
  activo: number;
  hora: string;
  dia_semana: DiaSemana;
  id_terapeuta: number;
  flag_especial: boolean;
}

export class Marcacao {
  private marcacaoBD: Imarcacao;
  constructor(marcacao: Imarcacao) {
    this.marcacaoBD = marcacao;
  }

  public get id(): number | null{
    if(this.marcacaoBD.id){
      return this.marcacaoBD.id;
    }
    else {
      return null;
    }
    
  }

  public get dia_semana(): string{
    return this.marcacaoBD.dia_semana;
  }
  public get hora(): Date{
    return timeStringToDate(this.marcacaoBD.hora);
  }
}

export interface MarcacoesHelper {
  consulta: Iconsulta | null;
  cartao: Icartao | null;
  utente: Iutente | null;
  terapeutas: Iterapeuta[];
  marcacoes: any[]; // eslint-disable-line
  marcacoes_old: any[]; // eslint-disable-line
}

export function getMarcacoesHelpers(
  idConsulta: number | null,
  cbOk: (rBody: MarcacoesHelper) => void,
  cbError: errorFuncStruct
): void {
  conection(
    "getMarcacoesHelpers.php",
    {idConsulta: idConsulta},
    (rBody) => { 
      // console.log(rBody);
      const returnHelpers: MarcacoesHelper = {
        consulta: rBody.consulta,
        cartao: rBody.cartao,
        utente: rBody.utente,
        terapeutas: rBody.terapeutas,
        marcacoes: rBody.marcacoes,
        marcacoes_old: rBody.marcacoes_old
      }
      cbOk(returnHelpers);
    },
    cbError
  );
}

export function getMapasHelpers(
  idConsulta: number | null,
  cbOk: (rBody: MarcacoesHelper) => void,
  cbError: errorFuncStruct
): void {
  conection(
    "getMapaHelpers.php",
    {idConsulta: idConsulta},
    (rBody) => { 
      // console.log(rBody);
      const returnHelpers: MarcacoesHelper = {
        consulta: rBody.consulta,
        cartao: rBody.cartao,
        utente: rBody.utente,
        terapeutas: rBody.terapeutas,
        marcacoes: rBody.marcacoes,
        marcacoes_old: rBody.marcacoes_old
      }
      cbOk(returnHelpers);
    },
    cbError
  );
}

export function saveMarcacoesServer(
  marcacoes: Imarcacao[],
  cbOk: () => void,
  cbError: errorFuncStruct
): void{
  conection(
    "saveMarcacoes.php",
    {marcacoes: marcacoes},
    cbOk,
    cbError
  );
}

export function retirarMarcacoesMapa(
  id_consulta: number, 
  cbOk: () => void,
  cbError: errorFuncStruct
): void{
  conection(
    "retirarMarcacoes.php",
    {id_consulta: id_consulta},
    cbOk,
    cbError
  )
}

export function marcacaoPresenca(
  id_marcacao: number, 
  status: number, 
  data: string,
  cbOk: () => void,
  cbError: errorFuncStruct
): void{
  conection(
    "toogleMarcacao.php",
    {id_marcacao: id_marcacao, status: status, data: data},
    cbOk,
    cbError
  )
}